module.exports = __webpack_public_path__ + "static/images/drivingPermit-1.0215919.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/drivingPermit-1.png
// module id = tIFI
// module chunks = 0